"use client";
import Image from "next/image";
import { useRef } from "react";
import Hero_Section from "./components/homescreen/hero_section";
export default function Home() {
  const scrollRef = useRef(null);
  const scrollRef1 = useRef(null);
  const scrollRef2 = useRef(null);

  const handleMouseEnter = () => {
    scrollRef.current?.scrollTo({
      top: 192,
      behavior: "smooth",
    });
  };

  const handleMouseLeave = () => {
    scrollRef.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleMouseEnter1 = () => {
    scrollRef1.current?.scrollTo({
      top: 192,
      behavior: "smooth",
    });
  };

  const handleMouseLeave1 = () => {
    scrollRef1.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleMouseEnter2 = () => {
    scrollRef2.current?.scrollTo({
      top: 192,
      behavior: "smooth",
    });
  };

  const handleMouseLeave2 = () => {
    scrollRef2.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Hero_Section />
      <div className="w-full flex justify-end">
        <Image
          src="/backgrounds/side_background_3.svg"
          width={100}
          height={100}
          alt="design"
        />
      </div>
      <div style={{ padding: "clamp(5%, 10vw, 15%)" }}>
        <div className="w-full flex flex-col text-center justify-center space-y-3 items-center py-5 lg:py-10 md:py-10">
          <span className="text-[28px] lg:text-[48px] md:text-[48px] font-bold">
            Why <span className="text-[#1CBFA2]">Choose</span> Us?
          </span>
          <span className="w-full   text-center text-[10px] lg:text-[18px] md:text-[16px] text-gray-500 ">
            Discover why thousands trust 2nd Line Phone Number ◎ for secure,
            seamless communication and unlimited calling and texting without a
            second SIM. Perfect for work, dating, travel, and privacy.Enjoy
            international connectivity, personalized numbers, call recording,
            voicemail, and call blocking all in one smart app.
          </span>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="relative  rounded-2xl border-fade p-6 hover:border-2 2px">
            {/* Content inside the bordered box */}
            <div className="flex flex-col items-center justify-center h-full space-y-3">
              <Image
                src="/sims.svg"
                alt="Icon"
                width={150}
                height={150}
                className="w-[150px] h-[150px]"
              />
              <span className="text-lg lg:text-[24px] font-bold mt-4">
                Second Number
              </span>
              <h2 className="text-sm lg:text-[16px] text-gray-500 text-center w-full lg:w-[230px] md:w-full leading-relaxed">
                Choose number and start sending text or call
              </h2>
            </div>
          </div>
          <div className="relative  rounded-2xl border-fade p-6">
            {/* Content inside the bordered box */}
            <div className="flex flex-col items-center justify-center h-full  space-y-3">
              <Image
                src="/privacy.svg"
                alt="Icon"
                width={150}
                height={150}
                className="w-[150px] h-[150px]"
              />
              <h2 className="text-lg lg:text-[24px] font-bold mt-4">
                Your number is safe
              </h2>
              <p className="text-sm lg:text-[16px] text-gray-500 text-center w-full lg:w-[230px] md:w-full leading-relaxed">
                Still private & anonymous with second number
              </p>
            </div>
          </div>
          <div className="relative  rounded-2xl border-fade p-6  space-y-3">
            {/* Content inside the bordered box */}
            <div className="flex flex-col items-center justify-center h-full  space-y-3">
              <Image
                src="/earth.svg"
                alt="Icon"
                width={150}
                height={150}
                className="w-[150px] h-[150px]"
              />
              <h2 className="text-lg font-bold mt-4 lg:text-[24px]">
                Global Access
              </h2>
              <div className="w-full lg:w-[230px] md:w-full">
                <p className="text-sm text-gray-500 text-center lg:text-[16px] leading-relaxed">
                  Outgoing call, text messages, MMS from cross country
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ padding: "clamp(5%, 10vw, 15%)" }}
        className="flex flex-col lg:flex-row md:flex-col justify-between items-center space-x-0 lg:space-x-16"
      >
        <div className="w-full lg:w-[450px]  flex flex-col space-y-3 text-center lg:text-left">
          <span className="text-[28px] lg:text-[48px] md:text-[48px] font-bold leading-tight ">
            Our <span className="text-[#1CBFA2]">Supporting</span> Country’s
          </span>
          <span className="w-full lg:w-[500px]  text-center lg:text-left text-[10px] lg:text-[18px] md:text-[16px] text-gray-500 ">
            Connect globally with 2nd Line Phone Number ◎ for seamless
            international calling and texting at affordable rates. Stay
            connected with friends, family, and business worldwide using our
            hassle-free iOS app.
          </span>
          <div className="hidden lg:flex space-x-2 justify-start items-end relative pb-10 pt-10">
            {/* Download App */}
            <a
              href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
              target="_blank"
              rel="noopener noreferrer"
              title="Download Second Phone Number app on the App Store"
              className="rounded-full border border-black p-3 flex items-center transition-all duration-300 hover:bg-[#1CBFA2] hover:border-white text-[#060A1F] hover:text-white text-[18px]  cursor-pointer"
            >
              Download App
            </a>

            {/* Apple Icon */}
            <a
              className="group rounded-full border border-black p-3 flex items-center cursor-pointer hover:bg-[#1CBFA2] hover:border-white hover:text-white"
              href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src="/appstore_icons/apple.svg"
                width={20}
                height={20}
                alt="apple"
                
                    className="filter group-hover:invert group-hover:brightness-0 group-hover:contrast-200 transition-all duration-300 mx-[2px]"
              />
            </a>
          </div>
        </div>
        <div className="relative w-full flex flex-col lg:flex-row justify-center items-center py-10 ">
          {/* Large Screen Image */}
          <div className="relative w-auto hidden lg:block">
            <object
              type="image/svg+xml"
              data="/second_line_mobile_images/mobile_view.svg"
              className="max-w-full h-auto object-contain"
            ></object>
            {/* Overflow Divs */}
            <div
              ref={scrollRef}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              className="absolute top-[40px] left-[-100px] bg-white shadow-lg p-4 rounded-lg w-[260px] h-[192px] space-y-2 overflow-auto scrollbar-hide "
            >
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/us.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">United States</span>
                  </div>
                  <span>+93</span>
                </div>
              </div>
              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/ar.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Argentina</span>
                  </div>
                  <span>+54</span>
                </div>
              </div>
              <hr />
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/am.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Armenia</span>
                  </div>
                  <span>+374</span>
                </div>
              </div>

              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/au.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Australia</span>
                  </div>
                  <span>+93</span>
                </div>
              </div>
              <hr />

              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/af.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Afghanistan</span>
                  </div>
                  <span>+93</span>
                </div>
              </div>
              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/ar.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Argentina</span>
                  </div>
                  <span>+54</span>
                </div>
              </div>
              <hr />
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/am.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Armenia</span>
                  </div>
                  <span>+374</span>
                </div>
              </div>

              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/au.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Australia</span>
                  </div>
                  <span>+93</span>
                </div>
              </div>
            </div>

            <div
              ref={scrollRef1}
              onMouseEnter={handleMouseEnter1}
              onMouseLeave={handleMouseLeave1}
              className="absolute bottom-[20px] left-[-200px] bg-white shadow-lg p-4 rounded-lg w-[260px] h-[192px] space-y-2 overflow-auto scrollbar-hide "
            >
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/fr.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">France</span>
                  </div>
                  <span>+33</span>
                </div>
              </div>
              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/fi.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Finland</span>
                  </div>
                  <span>+358</span>
                </div>
              </div>
              <hr />
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/de.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Germany</span>
                  </div>
                  <span>+49</span>
                </div>
              </div>

              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/gb.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">United Kingdom</span>
                  </div>
                  <span>+44</span>
                </div>
              </div>
              <hr />
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/fr.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">France</span>
                  </div>
                  <span>+33</span>
                </div>
              </div>
              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/fi.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Finland</span>
                  </div>
                  <span>+358</span>
                </div>
              </div>
              <hr />
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/de.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Germany</span>
                  </div>
                  <span>+49</span>
                </div>
              </div>

              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/gb.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">United Kingdom</span>
                  </div>
                  <span>+44</span>
                </div>
              </div>
              <hr />
            </div>

            <div
              ref={scrollRef2}
              onMouseEnter={handleMouseEnter2}
              onMouseLeave={handleMouseLeave2}
              className="absolute top-[300px] right-[-130px] bg-white shadow-lg p-4 rounded-lg w-[260px] h-[192px] space-y-2 overflow-auto scrollbar-hide"
            >
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/be.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Belgium</span>
                  </div>
                  <span>+32</span>
                </div>
              </div>
              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/ca.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Canada</span>
                  </div>
                  <span>+1</span>
                </div>
              </div>
              <hr />
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/dk.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Denmark</span>
                  </div>
                  <span>+45</span>
                </div>
              </div>

              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/eg.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Egypt</span>
                  </div>
                  <span>+20</span>
                </div>
              </div>
              <hr />
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/be.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Belgium</span>
                  </div>
                  <span>+32</span>
                </div>
              </div>
              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/ca.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Canada</span>
                  </div>
                  <span>+1</span>
                </div>
              </div>
              <hr />
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/dk.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Denmark</span>
                  </div>
                  <span>+45</span>
                </div>
              </div>

              <hr></hr>
              <div className="flex space-x-2 items-center">
                <Image
                  src="/country_codes/eg.svg"
                  width={30}
                  height={30}
                  alt="flag"
                  className="object-cover rounded-full"
                />

                <div className="w-full flex justify-between space-x-4 text-base">
                  <div>
                    <span className="text-base">Egypt</span>
                  </div>
                  <span>+20</span>
                </div>
              </div>
            </div>
          </div>
          <a href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162">
            <object
              type="image/svg+xml"
              data="/second_line_mobile_images/mobile_view_for_small_screen.svg"
              className="block lg:hidden md:block custom-image w-full items-start"
            ></object>
          </a>
        </div>
        <div className="flex lg:hidden space-x-2 justify-start items-end relative pb-10 pt-10">
          {/* Download App */}
          <a
            href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
            target="_blank"
            rel="noopener noreferrer"
            title="Download Second Phone Number app on the App Store"
            className="rounded-full border border-black p-3 flex items-center transition-all duration-300 hover:bg-[#1CBFA2] hover:border-white text-[#060A1F] hover:text-white text-[18px]  cursor-pointer"
          >
            Download App
          </a>

          {/* Apple Icon */}
          <a
            className="group rounded-full border border-black p-3 flex items-center hover:bg-[#1CBFA2] hover:border-white hover:text-white"
            href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src="/appstore_icons/apple.svg"
              width={20}
              height={20}
              alt="apple icon"
              
                    className="filter group-hover:invert group-hover:brightness-0 group-hover:contrast-200 transition-all duration-300 mx-[2px]"
            />
          </a>
        </div>
      </div>
      <div className="w-full flex justify-end">
        <Image
          src="/backgrounds/side_background_1.svg"
          width={100}
          height={100}
          alt="design"
        />
      </div>
      <div
        style={{
          backgroundImage: "url('/backgrounds/feature_section_background.svg')",
          backgroundSize: "cover", // Adjusts the image to cover the entire div
          backgroundRepeat: "no-repeat", // Prevents tiling
          backgroundPosition: "center center", // Centers the image
          width: "100%", // Ensure full width
          // Adjust height as needed
        }}
      >
        <div
          style={{ padding: "clamp(5%, 10vw, 15%)" }}
          className="w-full flex flex-col lg:flex-row  justify-between gap-5 items-center"
        >
          <div className="w-full lg:w-1/2  space-y-3 order-2 lg:order-1">
            <div className="flex flex-col lg:flex-row  space-x-0 lg:space-x-3  space-y-3 lg:space-y-0  w-full">
              <div
                style={{ width: "clamp(100%, 50%, 30vw, 260px)" }}
                className="group w-full border-fade "
              >
                <div
                  className=" p-5 lg:p-10 md:p-10
                  group-hover:text-white hover:bg-[#1CBFA2]
                  rounded-none group-hover:rounded-xl transition-all duration-500 ease-in-out space-y-3 flex flex-col h-auto lg:h-[260px] justify-between"
                >
                  <span className="text-lg font-bold lg:text-[24px] text-nowrap">
                    Our Features
                  </span>
                  <ul className="list-disc pl-4 space-y-4 text-sm  lg:text-[16px] text-gray-500 group-hover:text-white">
                    <li>Voicemail</li>

                    <li>Call Recording</li>
                    <li className="text-nowrap">Auto Reply Messages</li>
                    <li>App Contacts</li>

                    <hr className="bg-[#b5f9ed] h-1  rounded-lg" />
                  </ul>
                </div>
              </div>
              <div
                style={{ width: "clamp(100%, 50%, 30vw, 260px)" }}
                className="group w-full border-fade "
              >
                <div
                  className=" p-5 lg:p-10 md:p-10
                  group-hover:text-white hover:bg-[#1CBFA2]
                  rounded-none group-hover:rounded-xl transition-all duration-500 ease-in-out space-y-3 flex flex-col h-auto lg:h-[260px] justify-between"
                >
                  <span className="text-lg font-bold lg:text-[24px] text-nowrap">
                    Phone Numbers
                  </span>
                  <ul className="list-disc pl-4 space-y-4 text-sm  lg:text-[16px] text-gray-500 group-hover:text-white leading-relaxed">
                    <li>Choose your unique phone number</li>
                    <li>Personalized phone number</li>
                  </ul>

                  <hr className="bg-[#b5f9ed] h-1  rounded-lg" />
                </div>
              </div>
            </div>
            <div className="group border-fade w-full ">
              <div
                className=" p-5 lg:p-10 md:p-10
                  group-hover:text-white hover:bg-[#1CBFA2]
                  rounded-none group-hover:rounded-xl transition-all duration-500 ease-in-out
 h-auto lg:h-[260px] justify-between  space-y-3 flex flex-col"
              >
                <span className="text-lg font-bold lg:text-[24px]">
                  Multiple Phone Lines
                </span>
                <ul className="list-disc pl-4 space-y-2 text-sm lg:text-[16px] text-gray-500 group-hover:text-white leading-relaxed">
                  <li>No extra SIM card is needed</li>
                  <li>
                    Second Phone Number lets you manage multiple phone lines
                    effortlessly on your iOS device.
                  </li>
                </ul>
                <hr className="bg-[#b5f9ed] h-1  rounded-lg" />
              </div>
            </div>
            <div className="flex lg:hidden space-x-2 justify-center items-end relative pb-10 pt-10">
              {/* Download App */}
              <a
                href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
                target="_blank"
                rel="noopener noreferrer"
                title="Download Second Phone Number app on the App Store"
                className="rounded-full border border-black p-3 flex items-center transition-all duration-300 hover:bg-[#1CBFA2] hover:border-white text-[#060A1F] hover:text-white text-[18px]  cursor-pointer"
              >
                Download App
              </a>

              {/* Apple Icon */}
              <a
                className="group rounded-full border border-black p-3 flex items-center hover:bg-[#1CBFA2] hover:border-white hover:text-white"
                href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src="/appstore_icons/apple.svg"
                  width={20}
                  height={20}
                  alt="apple"
                    className="filter group-hover:invert group-hover:brightness-0 group-hover:contrast-200 transition-all duration-300 mx-[2px]"

                />
              </a>
            </div>
          </div>
          <div className="w-full lg:w-[450px]  flex flex-col space-y-3 order-1 lg:order-2 justify-center items-center lg:items-start">
            <h1 className="text-[28px] lg:text-[48px] md:text-[48px] font-bold leading-tight hidden lg:block md:block">
              <span className="text-[#1CBFA2]"> Choose </span> 2nd Line App
            </h1>
            <span className="text-[28px] lg:text-[48px] md:text-[48px] font-bold leading-tight block lg:hidden md:hidden">
              <span className="text-[#1CBFA2]"> Choose </span> 2nd Line App
            </span>
            <span className="w-full lg:w-[500px]  text-center lg:text-left text-[10px] lg:text-[18px] md:text-[16px] text-gray-500 ">
              Manage multiple phone lines with ease. Choose the 2nd Line Phone
              Number ◎ app today! Say goodbye to juggling devices or swapping
              SIMs. With our app, you can manage virtual phone lines for
              personal, business, or online use from one convenient dashboard.
              Get a custom number, block spam calls, and even record
              conversations, all while keeping your real number private.
              Designed for flexibility, privacy, and professionalism.
            </span>
            <div className="hidden lg:flex space-x-2 justify-start items-end relative pb-10 pt-10">
              {/* Download App */}
              <a
                href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
                target="_blank"
                title="Download Second Phone Number app on the App Store"
                rel="noopener noreferrer"
                className="rounded-full border border-black p-3 flex items-center transition-all duration-300 hover:bg-[#1CBFA2] hover:border-white text-[#060A1F] hover:text-white text-[18px]  cursor-pointer"
              >
                Download App
              </a>

              {/* Apple Icon */}
              <a
                className="group rounded-full border border-black p-3 flex items-center hover:bg-[#1CBFA2] hover:border-white hover:text-white"
                href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src="/appstore_icons/apple.svg"
                  width={20}
                  height={20}
                  alt="apple"
                
                    className="filter group-hover:invert group-hover:brightness-0 group-hover:contrast-200 transition-all duration-300 mx-[2px]"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-start">
        <Image
          src="/backgrounds/side_background_2.svg"
          width={100}
          height={100}
          alt="design"
        />
      </div>
      <div
        itemScope
        itemType="https://schema.org/Product"
        style={{ padding: "clamp(5%, 10vw, 15%)" }}
        className=" space-y-10"
      >
        {/* Product metadata */}
        <meta itemProp="name" content="2nd Line App" />
        <meta
          itemProp="description"
          content="2nd Line lets you manage multiple phone numbers on one device."
        />

        {/* ✅ Aggregate rating for Google Rich Results */}
        <div
          itemProp="aggregateRating"
          itemScope
          itemType="https://schema.org/AggregateRating"
        >
          <meta itemProp="ratingValue" content="4.5" />
          <meta itemProp="reviewCount" content="4" />
        </div>

        <div className="w-full flex flex-col justify-center text-center space-y-5 items-center">
          <span className="text-[28px] lg:text-[48px] md:text-[48px] font-bold leading-tight">
            <span>User</span> <span className="text-[#1CBFA2]">Reviews</span>
          </span>
          <span className="text-gray-500 text-[10px] lg:text-[18px]  md:text-[16px] w-full ">
            Rated highly by real users, trusted for privacy, clarity, and
            convenience. From professionals to travelers, thousands rely on 2nd
            Line Phone Number ◎ for secure, affordable, and flexible
            communication. Try it today and experience the difference.
          </span>
        </div>

        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5">
          <div>
            {/* Review 1 */}
            <div
              itemProp="review"
              itemScope
              itemType="https://schema.org/Review"
              className="w-full  p-5 lg:p-10 md:p-10 border-fade flex space-x-3 items-start"
            >
              <object type="image/svg+xml" data="/users/user1.svg"></object>
              <div className="flex flex-col space-y-3">
                <span
                  className="text-lg font-bold"
                  itemProp="author"
                  itemScope
                  itemType="https://schema.org/Person"
                >
                  <span itemProp="name">Kristin Watson</span>
                </span>
                <span
                  className="text-gray-500 mr-5 text-sm lg:text-md"
                  itemProp="reviewBody"
                >
                  Hi, Not Hapie, we are delighted to hear that you are satisfied
                  with your second number! Your satisfaction is our ultimate
                  goal.
                </span>
              </div>
            </div>

            {/* Review 2 */}
            <div
              itemProp="review"
              itemScope
              itemType="https://schema.org/Review"
              className="w-full  p-5 lg:p-10 md:p-10 border-fade flex space-x-3 items-start"
            >
              <object type="image/svg+xml" data="/users/user2.svg"></object>
              <div className="flex flex-col space-y-3">
                <span
                  className="text-lg font-bold"
                  itemProp="author"
                  itemScope
                  itemType="https://schema.org/Person"
                >
                  <span itemProp="name">Darrell Steward</span>
                </span>
                <span
                  className="text-gray-500 mr-5 text-sm lg:text-md"
                  itemProp="reviewBody"
                >
                  We are delighted to hear that you are satisfied with your
                  second number! Your satisfaction is our ultimate goal, and we
                  are here to ensure everything.
                </span>
              </div>
            </div>
          </div>

          <div className="mt-0 lg:mt-10 md:mt-10">
            {/* Review 3 */}
            <div
              itemProp="review"
              itemScope
              itemType="https://schema.org/Review"
              className="w-full  p-5 lg:p-10 md:p-10 border-fade flex space-x-3 items-start"
            >
              <object type="image/svg+xml" data="/users/user3.svg"></object>
              <div className="flex flex-col space-y-3">
                <span
                  className="text-lg font-bold"
                  itemProp="author"
                  itemScope
                  itemType="https://schema.org/Person"
                >
                  <span itemProp="name">Theresa Webb</span>
                </span>
                <span
                  className="text-gray-500 mr-5 text-sm lg:text-md"
                  itemProp="reviewBody"
                >
                  We are delighted to hear that you are satisfied with your
                  second number! Your satisfaction is our ultimate goal, and we
                  are here to ensure everything.
                </span>
              </div>
            </div>

            {/* Review 4 */}
            <div
              itemProp="review"
              itemScope
              itemType="https://schema.org/Review"
              className="w-full  p-5 lg:p-10 md:p-10 border-fade flex space-x-3 items-start"
            >
              <object type="image/svg+xml" data="/users/user4.svg"></object>
              <div className="flex flex-col space-y-3">
                <span
                  className="text-lg font-bold"
                  itemProp="author"
                  itemScope
                  itemType="https://schema.org/Person"
                >
                  <span itemProp="name">Jerome Bell</span>
                </span>
                <span
                  className="text-gray-500 mr-5 text-sm lg:text-md"
                  itemProp="reviewBody"
                >
                  Happy, We are delighted to hear that you are satisfied with
                  your second number! Your satisfaction is our ultimate goal.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full flex justify-end">
        <Image
          src="/backgrounds/side_background_1.svg"
          width={100}
          height={100}
          alt="design"
        />
      </div>
    </>
  );
}
